/**
 * Пустой холст (блок не выбран): машущий маскот прямо на тёмном холсте и светлое
 * облачко-реплика СЛЕВА от него, на уровне бровей; хвостик смотрит вправо — к
 * рту, будто маскот это и говорит. Подсказка, что делать дальше, вместо
 * безликой иконки.
 */
export const EmptyCanvasMascot = ({ message }: { message: string }) => (
  <div className="flex h-full w-full items-center justify-center px-6">
    <div className="flex items-start">
      <div className="relative z-10 -mr-10 mt-[58px] max-w-[260px] rounded-2xl bg-foreground px-5 py-3.5 text-base font-medium leading-snug text-background">
        {message}
        {/* Хвостик у правого края, чуть ниже середины — в сторону рта. */}
        <span
          aria-hidden
          className="absolute -right-1.5 top-[62%] size-4 -translate-y-1/2 rotate-45 bg-foreground"
        />
      </div>
      <img src="/icons/mascot-wave.svg" alt="" className="w-56 shrink-0" />
    </div>
  </div>
)
